import S from './RecruitmentCard.module.scss';

import bookmarkCheckedIcon from '../../ivy/Home/assets/bookmark_checked.svg';
import bookmarkIcon from '../../ivy/Home/assets/bookmark.svg';
import defaultThumbImg from '../../ivy/Home/assets/default_thumbnail.png';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Bookmark from '../Bookmark';
import { RecruitmentContentType } from '../../../types/RecruitmentTypes';
import { DateTimeUtils } from '../../../utils/DateTimeUtils';
import _ from 'lodash';

interface RecruitmentCardProps {
  content: RecruitmentContentType;
}

const RecruitmentCard = (props: RecruitmentCardProps) => {
  const { content } = props;
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const navigate = useNavigate();
  const [recruitId, setRecruitId] = useState<string>('1');

  const checkLastEndDate = () => {
    if (DateTimeUtils.calculateDaysRemaining(content.endAt) === 0) {
      return (
        <>
          <span className="point-color">오늘마감</span>
        </>
      );
    } else if (
      Number(DateTimeUtils.calculateDaysRemaining(content.endAt)) > 0 &&
      Number(DateTimeUtils.calculateDaysRemaining(content.endAt)) <= 7
    ) {
      return (
        <>
          <span className="point-color">
            D-{DateTimeUtils.calculateDaysRemaining(content.endAt)}
          </span>
        </>
      );
    } else {
      return <>D-{DateTimeUtils.calculateDaysRemaining(content.endAt)}</>;
    }
  };

  useEffect(() => {
    setIsBookmarked(content.isBookmarked);
  }, [content]);

  if (content === undefined) {
    return null;
  }

  return (
    <div
      className={S.postcard_box}
      onClick={(e) => {
        navigate(`/recruitment/${content.id}`);
      }}
    >
      <div className={S.bookmark_icon_area}>
        <Bookmark id={content.id} isBookmarked={isBookmarked} setIsBookmarked={setIsBookmarked} />
      </div>
      <div className={S.thumbnail_img}>
        <img src={content.company?.imageUrl || defaultThumbImg} alt="기본 이미지" />
      </div>
      <div className={S.postcard_text_area}>
        <p className={`${S.company_title} b2`}>{content.company.name || ''}</p>
        <div className={`${S.post_title_area} text-line-2-wrapper`}>
          <h4 className={`${S.post_title} h4`}>{content.title}</h4>
        </div>
        {/* <p className={`${S.recruit_deadline} b2`}>
          {_.isEmpty(content?.endAt)
            ? ''
            : `D-${DateTimeUtils.calculateDaysRemaining(content.endAt)}`}
        </p> */}
        <p className={`${S.recruit_deadline} b2`}>
          {_.isEmpty(content?.endAt) ? '' : <>{checkLastEndDate()}</>}
        </p>
      </div>
    </div>
  );
};

export default RecruitmentCard;
